if (!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
    constructor() {
      super();
      this.isSticky = false;
      this.stickyThreshold = 0;
      this.isMobile = window.innerWidth < 769;
      this.footer = document.querySelector('footer');
      this.submitButton = this.querySelector('.product-form__submit');
      this.submitSpan = this.querySelector('.product-form__submit span');
      
      // Bind methods to preserve context
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (this.isMobile) {
        this.initStickyBehavior();
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 769;
      
      if (wasMobile !== this.isMobile) {
        if (this.isMobile) {
          this.initStickyBehavior();
          window.addEventListener('scroll', this.handleScroll);
        } else {
          this.resetStyles();
          window.removeEventListener('scroll', this.handleScroll);
        }
      }
    }

    initStickyBehavior() {
      // Set initial sticky threshold
      this.stickyThreshold = this.offsetTop;
    }

    handleScroll() {
      if (!this.isMobile) return;

      const currentScroll = window.scrollY;
      const shouldBeSticky = currentScroll >= this.stickyThreshold;
      
      // Handle sticky positioning
      if (shouldBeSticky && !this.isSticky) {
        this.setStickyStyles();
        this.isSticky = true;
      } else if (!shouldBeSticky && this.isSticky) {
        this.resetStyles();
        this.isSticky = false;
      }

      // Handle footer color changes
      this.handleFooterColorChange(currentScroll);
    }

    setStickyStyles() {
      this.classList.add('sticky');
    }

    resetStyles() {
      this.classList.remove('sticky');
    }

    handleFooterColorChange(currentScroll) {
      if (!this.footer || !this.submitButton || !this.submitSpan) return;

      const footerOffset = this.footer.offsetTop;
      const footerHeight = this.footer.offsetHeight;
      const threshold = footerOffset - footerHeight;

      if (currentScroll >= threshold) {
        this.classList.add('in-footer');
      } else {
        this.classList.remove('in-footer');
      }
    }
  }

  customElements.define('product-buttons', ProductButtons);
}